import React, { useContext } from 'react'
import { ExperimentClient, ExperimentClientProvider } from '@deal/experiment-js'
import { IdentityContext } from '#src/containers/Identity'
import { AnalyticsContext } from '../Analytics'

export interface UserExperimentClientProviderProps {
  experimentClient: ExperimentClient
  overrideId?: string
  forceExperimentDefaults?: boolean
}

const UserExperimentClientProvider: React.SFC<UserExperimentClientProviderProps> = ({
  overrideId,
  experimentClient,
  children
}) => {
  const { myself, experimentUserId } = useContext(IdentityContext)
  const analytics = useContext(AnalyticsContext)
  const isImpersonating = myself && myself.user.id !== myself.realUser.id
  const lastTouch = analytics?.lastTouch
  const attrs = lastTouch ? lastTouch.attributes : {}

  return (
    <ExperimentClientProvider
      experimentClient={experimentClient}
      id={overrideId || experimentUserId || ''}
      attributes={attrs}
      options={{
        suppressTracking: isImpersonating || undefined
      }}
    >
      {children}
    </ExperimentClientProvider>
  )
}

export default UserExperimentClientProvider
